import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const Footer = styled.footer`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  margin-top: 3rem;
  padding-top: 1.5rem;
  border-top: 1px solid var(--border-color);
  font-family: "IBM Plex Sans", sans-serif;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05rem;

  a {
    color: var(--accent);
    border-bottom: 1px solid transparent;

    &:hover {
      color: var(--accent-hover);
      border-bottom-color: currentColor;
    }
  }

  span {
    color: var(--text-muted);
    opacity: 0.5;
  }
`;

const FooterBackLink = styled(Link)`
  grid-column: 1;
  justify-self: start;
`;

const FooterLinks = styled.div`
  grid-column: 2;
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

export default function BlogPageFooter() {
  return (
    <Footer>
      <FooterBackLink to="/" onClick={() => window.scrollTo(0, 0)}>
        ← See all projects
      </FooterBackLink>
      <FooterLinks>
        <Link to="/" onClick={() => window.scrollTo(0, 0)}>sjurs.com</Link>
        <span>•</span>
        <a href="https://www.linkedin.com/in/sjurs/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
        <span>•</span>
        <a href="https://github.com/sjur" target="_blank" rel="noopener noreferrer">GitHub</a>
      </FooterLinks>
    </Footer>
  );
}
